import React from 'react';
import WhiteBoard from '../Components/WhiteBoard';

function Sketch() {
  return <WhiteBoard />;
}

export default Sketch;